import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { HOADONTHANHTOAN_API } from '@app/utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { messageToast, status200 } from '../../../../utils/define';
import HoaDonThanhToanForm, { normalizeInvoice } from './HoaDonThanhToanForm';

const HoaDonThanhToanEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const id = new URLSearchParams(useLocation().search.substring(1)).get('id');
    const query = useQuery(['hoaDonThanhToan', id], () => Get(HOADONTHANHTOAN_API.GET_ITEM, id), { enabled: !!id });
    const mutation = useMutation((value) => Put(HOADONTHANHTOAN_API.UPDATE_ITEM, id, value));
    const onSubmit = (values) => mutation.mutate(values, {
        onSuccess: (res) => {
            if (res.status !== status200) return toast.error(messageToast.messageToastUpdateError);
            toast.success(messageToast.messageToastUpdateSuccess);
            queryClient.setQueryData(['hoaDonThanhToan', id], values);
            history.push(URI_INTERNAL.HOADONTHANHTOAN_PATH);
        },
        onError: (err) => toast.error(err?.message || messageToast.messageToastTryCatch)
    });
    if (!id) return <div>Thiếu mã hóa đơn thanh toán</div>;
    if (query.isLoading) return <div>Đang tải...</div>;
    if (query.isError || !query.data) return <div>Không tìm thấy hóa đơn thanh toán</div>;
    return <HoaDonThanhToanForm title="Sửa hóa đơn thanh toán"
        initialValues={normalizeInvoice(query.data)} submitText="Cập nhật"
        isSubmitting={mutation.isLoading} onSubmit={onSubmit}
        onCancel={() => history.push(URI_INTERNAL.HOADONTHANHTOAN_PATH)} />;
};

export default HoaDonThanhToanEdit;
